var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { executeMethod, getDocumentList, getStandardDocumentList } from "./actions";
import { VirtualizedComboBox } from "@fluentui/react";
var AutoCompleteTextField = function (_a) {
    var label = _a.label, id = _a.id, options = _a.options, defaultKey = _a.defaultKey, _b = _a.required, required = _b === void 0 ? false : _b, onChange = _a.onChange, _c = _a.keyValuePair, keyValuePair = _c === void 0 ? { key: 'key', text: 'text' } : _c, className = _a.className;
    var dispatch = useDispatch();
    var _d = useState([]), list = _d[0], setList = _d[1];
    var _e = useState(), selectedKey = _e[0], setSelectedKey = _e[1];
    useEffect(function () {
        getRelatedDocumentList(options);
    }, [options]);
    useEffect(function () {
        if (defaultKey)
            getSelectedKey();
    }, [list]);
    var onSelect = function (e, option) {
        var _a, _b;
        onChange(id, (_a = option === null || option === void 0 ? void 0 : option.key) !== null && _a !== void 0 ? _a : '', (_b = option === null || option === void 0 ? void 0 : option.text) !== null && _b !== void 0 ? _b : '');
        setSelectedKey(option === null || option === void 0 ? void 0 : option.key);
    };
    var getSelectedKey = function () {
        var res = list === null || list === void 0 ? void 0 : list.find(function (line) { return (line === null || line === void 0 ? void 0 : line.key) == defaultKey || (line === null || line === void 0 ? void 0 : line.text) == defaultKey; });
        setSelectedKey(_.get(res, 'key'));
    };
    var getRelatedDocumentList = function (_a) {
        var type = _a.type, query = _a.query, _b = _a.filters, filters = _b === void 0 ? [] : _b, _c = _a.path, path = _c === void 0 ? "data" : _c, payload = _a.payload;
        return __awaiter(void 0, void 0, void 0, function () {
            var _d, standardLIst, sapList, list_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _d = type;
                        switch (_d) {
                            case 'Standard': return [3 /*break*/, 1];
                            case 'erp': return [3 /*break*/, 3];
                            case 'method': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, dispatch(getStandardDocumentList(query, filters, keyValuePair, path))];
                    case 2:
                        standardLIst = _e.sent();
                        setList(standardLIst);
                        return [3 /*break*/, 7];
                    case 3: return [4 /*yield*/, dispatch(getDocumentList(query, keyValuePair))];
                    case 4:
                        sapList = _e.sent();
                        setList(sapList);
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, dispatch(executeMethod(query, payload, keyValuePair))];
                    case 6:
                        list_1 = _e.sent();
                        setList(list_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var textFieldMarkup = (_jsx(VirtualizedComboBox, { className: className, selectedKey: selectedKey, required: required, label: label, allowFreeform: true, autoComplete: "on", options: list, onChange: onSelect, useComboBoxAsMenuWidth: true }));
    return (textFieldMarkup);
};
export default React.memo(AutoCompleteTextField);
